const PHONE_REGEXP = /^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[3-8]{1})|(18[0-9]{1})|(19[0-9]{1})|(14[5-7]{1}))+\d{8})$/;

export const validatePhone = (phone: string): boolean => {
    return PHONE_REGEXP.test(phone);
};

/** 校验数字 */
export const validateNumber = (value: unknown) => {
    // 这里简单地示范一个检查是否为数字的例子
    if (typeof value === "number") {
        return true;
    } else if (typeof value === "string") {
        // 使用 parseInt() 或 parseFloat() 来验证字符串是否为数字
        return !Number.isNaN(Number.parseFloat(value));
    }
    // 如果 value 不是 string 或 number 类型，可以根据实际需求进行处理
    return false;
};

/** 校验小数 */
export const validateDecimal = (value: string | number, decimal: number) => {
    if (!validateNumber(value)) {
        return false;
    }
    // 如果指定了小数点位数，则检查小数点位数是否符合要求
    if (decimal >= 0) {
        const decimalPlaces = (value.toString().split(".")[1] || "").length;
        if (decimalPlaces > decimal) {
            return false;
        }
    }
    return true;
};

/** 校验最大值和最小值 */
export const validateNumRange = (value: string | number, max: number, min: number = 0, int: boolean = false) => {
    if (!validateNumber(value)) {
        return false;
    }
    // 将 value 转换为数字类型
    const numericValue = Number.parseFloat(value.toString());

    // 检查是否超出最大值范围
    if (numericValue > max) {
        return false;
    }

    // 检查是否低于最小值范围
    if (numericValue < min) {
        return false;
    }

    if (int) {
        return validateDecimal(value, 0);
    }

    // 如果通过以上验证，则表示在最大值和最小值范围内
    return true;
};

/** 校验正整数 */
export const validateInt = (value: string | number, max?: number) => {
    if (!validateNumber(value)) {
        return false;
    }
    if (!validateDecimal(value, 0)) {
        return false;
    }
    if (!validateNumRange(value, max ?? Number.MAX_SAFE_INTEGER, 1)) {
        return false;
    }
    return true;
};
